// utils/newYearTemplates.js

export const getNewYearTemplates = (t) => [
  { id: 'festif',        label: `🎉 ${t('new_year_card.festif')}` },
  { id: 'elegant',       label: `✨ ${t('new_year_card.elegant')}` },
  { id: 'hivernal',      label: `❄️ ${t('new_year_card.hivernal')}` },
  { id: 'luxe',          label: `💎 ${t('new_year_card.luxe')}` },
  { id: 'minimaliste',   label: `🤍 ${t('new_year_card.minimaliste')}` },
  { id: 'algorithmique', label: `🎲 ${t('new_year_card.surprise')}` },
];

// Générateur pseudo-aléatoire seedé (identique à celui des anniversaires)
const seededRandom = (seed) => {
  let s = seed;
  return () => {
    s = (s * 16807 + 0) % 2147483647;
    return (s - 1) / 2147483646;
  };
};

const generateAlgorithmicNewYearSVG = (recipientName, message, t) => {
  const seed = Math.floor(Math.random() * 2147483647);
  const rand = seededRandom(seed);

  // Palettes hivernales
  const palettes = [
    { bg1: '#0f3460', bg2: '#533483', accent1: '#e94560', accent2: '#f5a623', text: '#ffffff' },
    { bg1: '#1a1a2e', bg2: '#16213e', accent1: '#51b7c5', accent2: '#f5f6fa', text: '#ffffff' },
    { bg1: '#006d77', bg2: '#83c5be', accent1: '#ffddd2', accent2: '#edf6f9', text: '#003c43' },
    { bg1: '#0d1b2a', bg2: '#1b263b', accent1: '#415a77', accent2: '#778da9', text: '#e0e1dd' },
    { bg1: '#2d6a4f', bg2: '#1b4332', accent1: '#95d5b2', accent2: '#ffd166', text: '#ffffff' },
  ];
  const palette = palettes[Math.floor(rand() * palettes.length)];

  // Générer flocons de neige
  const snowflakes = [];
  for (let i = 0; i < 40; i++) {
    const x = rand() * 600;
    const y = rand() * 400;
    const size = 3 + rand() * 10;
    const color = palette.accent1;
    const opacity = 0.5 + rand() * 0.5;
    snowflakes.push(`<text x="${x.toFixed(1)}" y="${y.toFixed(1)}" font-size="${size.toFixed(1)}" fill="${color}" opacity="${opacity.toFixed(2)}">❄️</text>`);
  }

  // Générer étoiles filantes
  const shootingStars = [];
  for (let i = 0; i < 6; i++) {
    const x1 = rand() * 600;
    const y1 = rand() * 200;
    const x2 = x1 + (rand() - 0.3) * 150;
    const y2 = y1 + 30;
    const color = palette.accent2;
    const opacity = 0.6 + rand() * 0.4;
    shootingStars.push(`<line x1="${x1.toFixed(1)}" y1="${y1.toFixed(1)}" x2="${x2.toFixed(1)}" y2="${y2.toFixed(1)}" stroke="${color}" stroke-width="${(1 + rand() * 2).toFixed(1)}" opacity="${opacity.toFixed(2)}"/>`);
    shootingStars.push(`<text x="${x2.toFixed(1)}" y="${y2.toFixed(1)}" font-size="12" fill="${color}" opacity="${opacity.toFixed(2)}">✨</text>`);
  }

  // Générer sapins stylisés
  const trees = [];
  for (let i = 0; i < 3; i++) {
    const x = 100 + rand() * 400;
    const y = 250 + rand() * 100;
    const size = 20 + rand() * 30;
    const color = palette.accent1;
    trees.push(`<polygon points="${(x - size/2).toFixed(1)},${y.toFixed(1)} ${x.toFixed(1)},${(y - size).toFixed(1)} ${(x + size/2).toFixed(1)},${y.toFixed(1)}" fill="${color}" opacity="0.7"/>`);
    trees.push(`<rect x="${(x - 5).toFixed(1)}" y="${(y + 5).toFixed(1)}" width="10" height="20" fill="#5a3e2b" opacity="0.8"/>`);
  }

  const msg = message || `${t('new_year_card.happy_new_year')} ${recipientName} !`;
// 🧠 wrap texte
  const wrapText = (text, maxChars = 50) => {
    const words = text.split(' ');
    const lines = [];
    let line = '';

    words.forEach(word => {
      const testLine = line ? `${line} ${word}` : word;
      if (testLine.length > maxChars) {
        lines.push(line);
        line = word;
      } else {
        line = testLine;
      }
    });

    if (line) lines.push(line);
    return lines;
  };

  const messageLines = wrapText(msg, 70);

  return `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgAlgo" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:${palette.bg1}"/>
      <stop offset="100%" style="stop-color:${palette.bg2}"/>
    </linearGradient>
    <linearGradient id="textGrad" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" style="stop-color:${palette.accent1}"/>
      <stop offset="100%" style="stop-color:${palette.accent2}"/>
    </linearGradient>
  </defs>

  <!-- Fond -->
  <rect width="600" height="400" fill="url(#bgAlgo)"/>

  <!-- Flocons de neige -->
  ${snowflakes.join('\n  ')}

  <!-- Étoiles filantes -->
  ${shootingStars.join('\n  ')}

  <!-- Sapins -->
  ${trees.join('\n  ')}

  <!-- Bandeau central semi-transparent -->
  <rect x="0" y="140" width="600" height="130" fill="rgba(0,0,0,0.35)" rx="0"/>

  <!-- Texte -->
  <text x="300" y="185" text-anchor="middle"
        font-family="Georgia, serif" font-size="18"
        fill="${palette.accent1}" letter-spacing="4" opacity="0.9">
    ✦ ${t('new_year_card.happy_new_year_upper')} ✦
  </text>
  <text x="300" y="235" text-anchor="middle"
        font-family="Georgia, serif" font-size="42" font-weight="bold"
        fill="url(#textGrad)">
    ${recipientName}
  </text>
  <text x="300" y="310" text-anchor="middle"
        font-family="Georgia, serif" font-size="16"
        fill="${palette.text}" font-style="italic" opacity="0.85">
    ${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}

  </text>
</svg>`;
};

export const generateNewYearSVG = (templateId, recipientName, message, t) => {
  const msg = message || `${t('new_year_card.happy_new_year')} ${recipientName} !`;
// 🧠 wrap texte
  const wrapText = (text, maxChars = 50) => {
    const words = text.split(' ');
    const lines = [];
    let line = '';

    words.forEach(word => {
      const testLine = line ? `${line} ${word}` : word;
      if (testLine.length > maxChars) {
        lines.push(line);
        line = word;
      } else {
        line = testLine;
      }
    });

    if (line) lines.push(line);
    return lines;
  };

  const messageLines = wrapText(msg, 70);

  if (templateId === 'algorithmique') {
    return generateAlgorithmicNewYearSVG(recipientName, message, t);
  }

  const templates = {

    festif: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgGrad" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#006064"/>
      <stop offset="100%" style="stop-color:#00838F"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgGrad)"/>
  <!-- Confettis -->
  <text x="50" y="60" font-size="20" fill="#FFF176">🎊</text>
  <text x="150" y="30" font-size="16" fill="#B2FF59">🎇</text>
  <text x="250" y="50" font-size="24" fill="#80D8FF">🎉</text>
  <text x="400" y="25" font-size="20" fill="#FF80AB">🎆</text>
  <text x="520" y="55" font-size="22" fill="#FFF176">🎈</text>
  <text x="570" y="100" font-size="18" fill="#B2FF59">🎊</text>
  <text x="30" y="200" font-size="20" fill="#FF80AB">🎇</text>
  <text x="580" y="300" font-size="20" fill="#80D8FF">🎉</text>
  <!-- Paillettes -->
  <circle cx="100" cy="370" r="5" fill="#FFF176" opacity="0.8"/>
  <circle cx="480" cy="380" r="6" fill="#B2FF59" opacity="0.8"/>
  <!-- Horloge minuit -->
  <circle cx="300" cy="180" r="40" fill="#FFF9C4" stroke="#FFD54F" stroke-width="3"/>
  <text x="300" y="185" text-anchor="middle" font-size="20" fill="#006064">🕛</text>
  <!-- Texte -->
  <text x="300" y="95" text-anchor="middle" font-family="Georgia, serif" font-size="36" font-weight="bold" fill="white">🎉 ${t('new_year_card.happy_new_year')}</text>
  <text x="300" y="135" text-anchor="middle" font-family="Georgia, serif" font-size="28" font-weight="bold" fill="#FFF176">${recipientName} !</text>
  <text x="300" y="300" text-anchor="middle" font-family="Georgia, serif" font-size="18" fill="white" font-style="italic">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
</svg>`,

    elegant: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgEleg" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#0f3460"/>
      <stop offset="100%" style="stop-color:#16213e"/>
    </linearGradient>
    <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" style="stop-color:#BF953F"/>
      <stop offset="50%" style="stop-color:#FCF6BA"/>
      <stop offset="100%" style="stop-color:#BF953F"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgEleg)"/>
  <!-- Bordure dorée -->
  <rect x="20" y="20" width="560" height="360" fill="none" stroke="url(#goldGrad)" stroke-width="2"/>
  <!-- Étoiles dorées -->
  <text x="120" y="120" text-anchor="middle" font-size="20" fill="#FCF6BA" opacity="0.6">✦</text>
  <text x="480" y="120" text-anchor="middle" font-size="20" fill="#FCF6BA" opacity="0.6">✦</text>
  <text x="120" y="300" text-anchor="middle" font-size="20" fill="#FCF6BA" opacity="0.6">✦</text>
  <text x="480" y="300" text-anchor="middle" font-size="20" fill="#FCF6BA" opacity="0.6">✦</text>
  <!-- Horloge élégante -->
  <circle cx="300" cy="200" r="30" fill="none" stroke="url(#goldGrad)" stroke-width="2"/>
  <line x1="300" y1="180" x2="300" y2="170" stroke="url(#goldGrad)" stroke-width="2"/>
  <line x1="300" y1="200" x2="310" y2="200" stroke="url(#goldGrad)" stroke-width="2"/>
  <!-- Texte -->
  <text x="300" y="150" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="#FCF6BA" letter-spacing="6">${t('new_year_card.happy_new_year_upper')}</text>
  <text x="300" y="195" text-anchor="middle" font-family="Georgia, serif" font-size="42" font-weight="bold" fill="url(#goldGrad)">${recipientName}</text>
  <text x="300" y="240" text-anchor="middle" font-family="Georgia, serif" font-size="14" fill="#FCF6BA" opacity="0.6">✦ ✦ ✦</text>
  <text x="300" y="280" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="#FCF6BA" font-style="italic">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
</svg>`,

    hivernal: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgHiver" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#E0F7FA"/>
      <stop offset="100%" style="stop-color:#B2EBF2"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgHiver)"/>
  <!-- Flocons de neige -->
  <text x="50" y="60" font-size="24">❄️</text>
  <text x="150" y="30" font-size="18">❄️</text>
  <text x="250" y="50" font-size="28">❄️</text>
  <text x="400" y="25" font-size="20">❄️</text>
  <text x="520" y="55" font-size="22">❄️</text>
  <!-- Bonhomme de neige -->
  <circle cx="300" cy="280" r="20" fill="white"/>
  <circle cx="300" cy="250" r="15" fill="white"/>
  <circle cx="300" cy="220" r="10" fill="white"/>
  <circle cx="295" cy="215" r="2" fill="black"/>
  <circle cx="305" cy="215" r="2" fill="black"/>
  <line x1="300" y1="225" x2="300" y2="235" stroke="orange" stroke-width="2"/>
  <text x="300" y="200" font-size="16">☃️</text>
  <!-- Texte -->
  <text x="300" y="150" text-anchor="middle" font-family="Georgia, serif" font-size="22" fill="#006064">❄️ ${t('new_year_card.happy_new_year')} ❄️</text>
  <text x="300" y="205" text-anchor="middle" font-family="Georgia, serif" font-size="40" font-weight="bold" fill="#00838F">${recipientName}</text>
  <text x="300" y="250" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="#006064" font-style="italic">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
</svg>`,

    luxe: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="bgLuxe" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#263238"/>
      <stop offset="100%" style="stop-color:#455A64"/>
    </linearGradient>
    <linearGradient id="goldLuxe" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" style="stop-color:#FFD700"/>
      <stop offset="100%" style="stop-color:#FFA500"/>
    </linearGradient>
  </defs>
  <rect width="600" height="400" fill="url(#bgLuxe)"/>
  <!-- Étoiles dorées -->
  <text x="100" y="100" font-size="24" fill="url(#goldLuxe)">✨</text>
  <text x="500" y="100" font-size="24" fill="url(#goldLuxe)">✨</text>
  <text x="300" y="300" font-size="28" fill="url(#goldLuxe)">✨</text>
  <!-- Feu d'artifice -->
  <line x1="300" y1="300" x2="250" y2="250" stroke="url(#goldLuxe)" stroke-width="2" stroke-dasharray="5,3"/>
  <line x1="300" y1="300" x2="350" y2="250" stroke="url(#goldLuxe)" stroke-width="2" stroke-dasharray="5,3"/>
  <line x1="300" y1="300" x2="280" y2="220" stroke="url(#goldLuxe)" stroke-width="2" stroke-dasharray="5,3"/>
  <!-- Texte -->
  <text x="300" y="150" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="url(#goldLuxe)" letter-spacing="6">${t('new_year_card.happy_new_year_upper')}</text>
  <text x="300" y="200" text-anchor="middle" font-family="Georgia, serif" font-size="44" font-weight="bold" fill="url(#goldLuxe)">${recipientName}</text>
  <text x="300" y="240" text-anchor="middle" font-family="Georgia, serif" font-size="16" fill="url(#goldLuxe)" font-style="italic">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
  <!-- Bordure dorée -->
  <rect x="30" y="30" width="540" height="340" fill="none" stroke="url(#goldLuxe)" stroke-width="1"/>
</svg>`,

    minimaliste: `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">
  <rect width="600" height="400" fill="#FAFAFA"/>
  <!-- Ligne décorative -->
  <line x1="100" y1="180" x2="500" y2="180" stroke="#E0E0E0" stroke-width="1"/>
  <!-- Point central -->
  <circle cx="300" cy="100" r="20" fill="none" stroke="#333" stroke-width="1.5"/>
  <text x="300" y="110" text-anchor="middle" font-size="24">🎍</text>
  <!-- Texte -->
  <text x="300" y="165" text-anchor="middle" font-family="Georgia, serif" font-size="13" fill="#999" letter-spacing="4">${t('new_year_card.happy_new_year_upper')}</text>
  <text x="300" y="222" text-anchor="middle" font-family="Georgia, serif" font-size="44" font-weight="bold" fill="#333">${recipientName}</text>
  <text x="300" y="265" text-anchor="middle" font-family="Georgia, serif" font-size="15" fill="#777" font-style="italic">${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
</text>
  <!-- Petits points décoratifs -->
  <circle cx="200" cy="210" r="2" fill="#CCC"/>
  <circle cx="300" cy="210" r="2" fill="#CCC"/>
  <circle cx="400" cy="210" r="2" fill="#CCC"/>
</svg>`,

  };

  return templates[templateId] || templates['festif'];
};